import { useQuery } from '@tanstack/react-query';

import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import { getUserById, getUsers } from '../services/userServices';

export const useGetUsers = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['users', paginatedParams, searchCriteria],
    queryFn: () => getUsers(paginatedParams, searchCriteria),
    enabled,
  });
};

export const useGetUserById = (id: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => getUserById(id),
    enabled,
    cacheTime: 0,
    refetchOnMount: 'always',
  });
};
